<template>
	<v-row :id="'cn_header_' + section" v-if="question" class="cn_header" :class="{active: current == section}">
		<v-col class="pb-1 pt-1" cols="6" md="8">		
			<span v-if="question" class="plain-link" @click="goToSection">{{question.title}}</span>
		</v-col>
		<v-col cols="6" md="4" class="pb-1 pt-1 text-right">
			<ScoreBadge :level="section"></ScoreBadge>
			<v-tooltip top>
				<template v-slot:activator="{ on }">
					<v-progress-circular class="mr-2 remove_clone" size="30" :color="completionRateColor" :value="compRate" ref="progress" v-on="on">
						<span class="caption">{{compRate || 0 }}</span>
					</v-progress-circular>
				</template>
				<span>Fortschritt</span>
			</v-tooltip>
			<v-tooltip top>
				<template v-slot:activator="{ on }">
					<v-btn class="mr-1" v-on="on" @click="share_dialog = 1" icon color="primary"><v-icon>mdi-share-variant</v-icon></v-btn>
				</template>
				<span>Delegieren</span>
			</v-tooltip>
			<v-tooltip top>
				<template v-slot:activator="{ on }">
					<v-btn class="mr-1" v-on="on" @click="complete_dialog = 1" icon color="green"><v-icon>mdi-check-circle</v-icon></v-btn>
				</template>
				<span>Abschliessen & Absenden</span>
			</v-tooltip>

<!-- 			<v-btn x-small rounded color="primary" class="ml-2" dark><v-icon x-small class="mr-1">mdi-share-variant</v-icon>Delegieren</v-btn>
			<v-btn x-small rounded color="primary" class="ml-2" dark><v-icon x-small class="mr-1">mdi-poll</v-icon>Umfrage</v-btn>
			<v-btn x-small rounded color="green" class="ml-2" dark><v-icon x-small class="mr-1">mdi-check-circle</v-icon>Abschließen</v-btn>
 -->		</v-col>
		<v-dialog width="400" v-model="share_dialog">
			<v-card>
				<NewCollaboration setType="poll" @close="share_dialog = 0" ></NewCollaboration>
			</v-card>
		</v-dialog> 
		<v-dialog width="400" v-model="complete_dialog">
			<v-card>
				<v-card-title>Abschliessen & Absenden</v-card-title>
				<v-card-text>
					<p>Hiermit schließen Sie diesen Erhebungsteil ab. Ein weiteres Bearbeiten ist hiermit nicht mehr möglich.</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="red" rounded @click="complete_dialog = false">Abbrechen</v-btn>
					<v-btn color="primary" rounded @click="complete_dialog = false">Bestätigen</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog> 
	</v-row>	
</template>

<style lang="less">
	.hidden{
		display: none !important;
	}
	.plain-link{
		cursor: pointer;
		color: inherit !important;
		text-decoration: none;
	}
	.row.active{
		background-color: #eee;
	}

	.cn_header{
	}
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	import ScoreBadge from "@/components/assessment/content/ScoreBadge"
	import NewCollaboration from "@/components/assessment/collaborations/NewCollaboration"
	export default {
		name: "SectionToolbar", 
		props: {
			current: {type: String},
			section: {type: String},
			response: {type: Object }
		},
		data: () => {
			return {
				complete_dialog: false,
				share_dialog: false, 
			}
		},
		components: {
			ScoreBadge,
			NewCollaboration
		},
		computed: {
			compRate(){
				return this.response.completion_rate[this.section] || 0
			},
			question() {
				return window.S.getQuestionByName(this.section)
			},
			completionRateColor(){
				if( this.compRate > 70 ){
					return "green"
				}
				if( this.compRate > 40 ){
					return "primary"
				}
				if( this.compRate == 0 ){
					return "grey"
				}
				return "orange"
			}
		},
		watch: {
			// compRate(){
			// 	var e = this.$refs.progress.$el;
			// 	var h = document.getElementById(`cn_header_${this.section}_clone`);
			// 	var p = h.getElementsByClassName('v-progress-circular')[0];
			// 	p.outerHTML = e.outerHTML;
			// }
		},
		methods: {
			goToSection(){
				this.$emit('close');
				// if( this.current !== this.section ){
					var e  = document.getElementById(this.question.id);
					// this.smoothScroll(e)
					var pos = e.offsetTop;
					window.scrollTo( 0, pos);
				// }
			}
		}
		// created(){
			
		// }

	}
</script>"